import flatten from 'lodash/flatten';
import times from 'lodash/times';
import { stringify } from 'qs';

import { HttpResponse } from '../CAD.types';

export const DEFAULT_INITIAL_OFFSET = 0;
export const DEFAULT_INITIAL_LIMIT = 100;

export const addPaginatedParams = (url: string, offset: number, limit: number): string =>
	`${url}?${stringify({ offset, limit })}`;

export async function getCallPaginated<T>(
	getCall: Function,
	initialOffset = DEFAULT_INITIAL_OFFSET,
	initialLimit = DEFAULT_INITIAL_LIMIT,
): Promise<HttpResponse<T>> {
	try {
		const result = await getCall(initialOffset, initialLimit);
		const { response, data } = result;
		const { total, limit } = data.paging;
		const count = Math.ceil(total / limit);
		const calls: Promise<HttpResponse<T>>[] = [];
		times(count - 1, i => {
			calls.push(getCall((i + 1) * limit, limit));
		});

		const pages = await Promise.all(calls);

		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		const results = flatten([result, ...pages].map(({ data: d }) => d.data));

		return {
			data: {
				data: results,
				paging: {
					offset: 0,
					limit: results.length,
					total: results.length,
				},
			},
			response,
		};
	} catch (e) {
		return {
			response: { ok: false },
			data: { paging: { limit: 0, offset: 0, total: 0 }, data: [] },
		};
	}
}
